import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'

const byUndefined = (className) => className !== 'undefined' && !!className

const Font = forwardRef((props, ref) => {
  const { element, className, type, weight, color, elementProps, ...otherProps } = props
    const classes = [className, styles[type], styles[weight], styles[color]].filter(byUndefined) // Remove falsy values
    const Component = element

  return <Component ref={ref} className={classes.join(' ')} {...otherProps} {...elementProps} />
})

Font.propTypes = {
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  elementProps: PropTypes.object,
  type: PropTypes.oneOf([
    'xLarge',
    'large',
    'medium',
    'heading',
    'bodyLarge',
    'body',
    'bodySmall',
    'capsHeading',
    'disclaimer',
    'inherit'
  ]),
  weight: PropTypes.oneOf(['regular', 'semiBold', 'bold', 'extraBold']),
  color: PropTypes.oneOf([
    'neutral',
    'lighter',
    'lighter2',
    'accent',
    'accent2',
    'primary',
    'secondary',
    'error',
    'white',
    'darkGrey'
  ])
}

Font.defaultProps = {
  element: 'p',
  type: 'body'
}

Font.displayName = 'Font'

export { Font as FontNoHoc }

export default Font
